import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"pa-0"},[_c(VRow,[_c(VCol,{attrs:{"cols":"12","lg":"6"}},[_c('grid',{attrs:{"items":_vm.applications,"mode":"application","cols":6}})],1),_c(VCol,{attrs:{"cols":"12","lg":"6"}},[_c('grid',{attrs:{"items":_vm.agents,"mode":"agent","cols":6}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }